<template>
    <div>
        <div v-if="loading" class="text-center my-8">
            <v-progress-circular indeterminate color="primary" />
            <div class="mt-2">
                Loading article details...
            </div>
        </div>
        <article-details
            v-else-if="articleId"
            class="mt-2"
            :scope="scope"
            :article-id="articleId" />
    </div>
</template>


<script>
import schemaMixin from '@/features/schemas/mixins/schemaMixin'
import { get } from '@/features/schemas/services/schemaApi';

export default {
    types: [
        "articleDetail"
    ],
    components: {
        articleDetails: () => import('@/features/articles/ArticleDetails.vue')
    },
    mixins: [schemaMixin],

    props: {
        itemId: {
            type: [Number, String],
            default: null
        },
        scope: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            articleId: null,
            loading: true
        }
    },
    async mounted() {
        try {
            await this.setArticleId();
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async setArticleId() {
            this.articleId = (await get(this.entityKey, this.scope, this.itemId)).articleId;
        }
    }
}
</script>
